module.exports = __webpack_public_path__ + "img/search-gray.21f2e2e1.svg";